<template>
	<div>
		<AppHeader title="1:1 문의 작성" is-history />

		<AppContent>
			<InquiryEdit />
		</AppContent>

		<AppFooter />
	</div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader';
import AppFooter from '@/components/common/AppFooter';
import AppContent from '@/components/common/AppContent';
import InquiryEdit from '@/components/InquiryEdit/InquiryEdit';

export default {
	components: {
		AppHeader,
		AppFooter,
		AppContent,
		InquiryEdit,
	},
};
</script>
